<template>
  <div class="chart-box">
    <span v-if="!Array.isArray(report) && !fromChart" class="filter-buttons">
      <div>
        <input
          class="filter"
          @click="changeFilter($event)"
          type="radio"
          name="filters"
          id="regular"
          value="regular"
          checked
        />
        <label class="filter-title" for="regular">REGULAR</label>
      </div>
      <div>
        <input
          class="filter"
          @click="changeFilter($event)"
          type="radio"
          name="filters"
          id="removed"
          value="removed"
        />
        <label class="filter-title" for="removed">REMOVED</label>
      </div>
      <div>
        <input
          class="filter"
          @click="changeFilter($event)"
          type="radio"
          name="filters"
          id="cc-decline"
          value="cc-decline"
        />
        <label class="filter-title" for="cc-decline">CC-DECLINE</label>
      </div>
    </span>

    <div class="deposits-data">
      <ul class="main-tabs" v-if="!fromChart">
        <li
          class="daily-stats-tabs"
          v-for="tab in statsTabs"
          :key="tab.id"
          :class="{ active: selectedStatsTab === tab.alias }"
          @click="selectedStatsTab = tab.alias"
          v-if="report[tab.alias]"
        >
          <span>
            {{ tab.name }} - {{ report[tab.alias][filterOption].length }}
          </span>
        </li>
      </ul>
      <div class="report-box">
        <ul
          v-if="!Array.isArray(report) && !fromChart"
          class="style-nav style2"
        >
          <li
            v-for="tab in secTabs"
            :key="tab.id"
            :class="{ active: selectedSecTab === tab.alias }"
            @click="selectedSecTab = tab.alias"
          >
            {{ tab.name }}
          </li>
        </ul>
        <div
          v-show="selectedStatsTab === tab.alias"
          v-if="report[tab.alias] && report[tab.alias][filterOption]"
          class="dep-report-tab"
          v-for="tab in statsTabs"
          :key="tab.id"
        >
          <div v-if="selectedSecTab === 'COUNT'">
            <table :id="tab.alias">
              <thead>
                <tr>
                  <th>
                    <button
                      @click="applySorting(0, 0, tab.alias)"
                      class="btn btn-default btn-sm override"
                    >
                      <span
                        class="fa"
                        :class="{
                          'fas fa-sort-numeric-down': sortOrder[0] === 'asc',
                          'fas fa-sort-numeric-up': sortOrder[0] === 'desc'
                        }"
                      ></span>
                    </button>
                    ID
                  </th>
                  <th>
                    <button
                      @click="applySorting(0, 1, tab.alias)"
                      class="btn btn-default btn-sm override"
                    >
                      <span
                        class="fa"
                        :class="{
                          'fas fa-sort-alpha-down': sortOrder[0] === 'asc',
                          'fas fa-sort-alpha-up': sortOrder[0] === 'desc'
                        }"
                      ></span>
                    </button>
                    MAIL
                  </th>

                  <th>
                    <button
                      @click="applySorting(0, 2, tab.alias)"
                      class="btn btn-default btn-sm override"
                    >
                      <span
                        class="fa"
                        :class="{
                          'fas fa-sort-alpha-down': sortOrder[0] === 'asc',
                          'fas fa-sort-alpha-up': sortOrder[0] === 'desc'
                        }"
                      ></span>
                    </button>
                    AGENT
                  </th>
                  <th>
                    <button
                      @click="applySorting(0, 3, tab.alias)"
                      class="btn btn-default btn-sm override"
                    >
                      <span
                        class="fa"
                        :class="{
                          'fas fa-sort-alpha-down': sortOrder[0] === 'asc',
                          'fas fa-sort-alpha-up': sortOrder[0] === 'desc'
                        }"
                      ></span>
                    </button>
                  </th>
                  <th>
                    <button
                      @click="applySorting(0, 4, tab.alias)"
                      class="btn btn-default btn-sm override"
                    >
                      <span
                        class="fa"
                        :class="{
                          'fas fa-sort-alpha-down': sortOrder[0] === 'asc',
                          'fas fa-sort-alpha-up': sortOrder[0] === 'desc'
                        }"
                      ></span>
                    </button>
                    BRKR
                  </th>
                  <th>
                    $/€
                  </th>
                  <th>
                    <button
                      @click="applySorting(1, 6, tab.alias)"
                      class="btn btn-default btn-sm override"
                    >
                      <span
                        class="fa"
                        :class="{
                          'fas fa-sort-numeric-down': sortOrder[0] === 'asc',
                          'fas fa-sort-numeric-up': sortOrder[0] === 'desc'
                        }"
                      ></span>
                    </button>
                    AMT
                  </th>
                  <th>
                    CC
                  </th>
                  <th>
                    CM
                  </th>
                  <th class="dep-bg">
                    <button
                      @click="applySorting(0, 9, tab.alias)"
                      class="btn btn-default btn-sm override"
                    >
                      <span
                        class="fa"
                        :class="{
                          'fas fa-sort-numeric-down': sortOrder[0] === 'asc',
                          'fas fa-sort-numeric-up': sortOrder[0] === 'desc'
                        }"
                      ></span>
                    </button>
                    <span>DATE</span>
                  </th>
                  <th class="dep-bg">
                    <button
                      @click="applySorting(0, 10, tab.alias)"
                      class="btn btn-default btn-sm override"
                    >
                      <span
                        class="fa"
                        :class="{
                          'fas fa-sort-numeric-down': sortOrder[0] === 'asc',
                          'fas fa-sort-numeric-up': sortOrder[0] === 'desc'
                        }"
                      ></span>
                    </button>
                    <span>
                      HR
                    </span>
                  </th>
                  <th></th>
                  <th class="reg-bg">
                    <button
                      @click="applySorting(0, 12, tab.alias)"
                      class="btn btn-default btn-sm override"
                    >
                      <span
                        class="fa"
                        :class="{
                          'fas fa-sort-numeric-down': sortOrder[0] === 'asc',
                          'fas fa-sort-numeric-up': sortOrder[0] === 'desc'
                        }"
                      ></span>
                    </button>
                    <span>REG</span>
                  </th>
                  <th class="reg-bg">
                    <button
                      @click="applySorting(0, 13, tab.alias)"
                      class="btn btn-default btn-sm override"
                    >
                      <span
                        class="fa"
                        :class="{
                          'fas fa-sort-numeric-down': sortOrder[0] === 'asc',
                          'fas fa-sort-numeric-up': sortOrder[0] === 'desc'
                        }"
                      ></span>
                    </button>
                    <span>HR</span>
                  </th>
                  <th></th>
                  <th class="diff-wrapper">
                    <button
                      @click="applySorting(1, 15, tab.alias)"
                      class="btn btn-default btn-sm override"
                    >
                      <span
                        class="fa"
                        :class="{
                          'fas fa-sort-numeric-down': sortOrder[0] === 'asc',
                          'fas fa-sort-numeric-up': sortOrder[0] === 'desc'
                        }"
                      ></span>
                    </button>
                    <div class="diff-tr">
                      <span>{{
                        stats[tab.alias][filterOption]["total_diff"]
                      }}</span>
                      <span>DIFF</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="dep in report[tab.alias][filterOption]"
                  :key="dep.id"
                >
                  <td>
                    <span
                      class="client_id_label tooltip-opener"
                      @click="filterClientById(dep.client_id)"
                      >{{ dep.client_id }}
                    </span>
                  </td>
                  <td>
                    <span class="client_id_label tooltip-opener">
                      {{ dep.client_email | truncate(7) }}
                      <span
                        v-if="dep.client_email.length > 0"
                        class="tooltip-text"
                        >{{ dep.client_email }}</span
                      >
                    </span>
                  </td>
                  <td>
                    <span class="client_id_label tooltip-opener">
                      {{ dep.user.first_name.substring(0, 5) }}
                      {{ dep.user.last_name | truncate(1) }}
                      <span
                        v-if="dep.user.full_name.length > 0"
                        class="tooltip-text"
                        >{{ dep.user.full_name }}</span
                      >
                    </span>
                  </td>
                  <td>
                    <img
                      class="country-flag"
                      :src="
                        '/img/flags/' +
                        dictionaries.general.countries
                          .find(place => place.id == dep.country_id)
                          .alpha2.toLowerCase() +
                        '.png'
                          ? '/img/flags/' +
                            dictionaries.general.countries
                              .find(place => place.id == dep.country_id)
                              .alpha2.toLowerCase() +
                            '.png'
                          : ''
                      "
                      alt="country-flag"
                    />
                  </td>
                  <td>
                    <span class="client_id_label tooltip-opener">
                      {{ dep.campaign.name | truncate(6) }}
                      <span
                        v-if="dep.campaign.name.length > 0"
                        class="tooltip-text"
                        >{{ dep.campaign.name }}</span
                      >
                    </span>
                  </td>
                  <td>
                    <span v-if="dep.currency_id !== null">{{
                      dep.currency.symbol
                    }}</span>
                  </td>
                  <td>
                    {{ dep.amount }}
                  </td>
                  <td>
                    <span v-if="dep.method_id !== null">
                      <span v-if="dep.method.id == 1">CC</span>
                      <span v-else>{{ dep.method.method | truncate(5) }}</span>
                    </span>
                  </td>
                  <td>
                    <i
                      v-if="dep.comment"
                      class="fas fa-ellipsis-h popup"
                      v-on:click="showComment(dep.id)"
                      ><span class="popuptext" :id="dep.id">{{
                        dep.comment | truncate(65)
                      }}</span></i
                    >
                  </td>
                  <td>{{ formatDate(dep.created_at) }}</td>
                  <td>{{ formatTime(dep.created_at) }}</td>
                  <td>
                    {{ timeIcons[checkTimeOfDay(formatTime(dep.created_at))] }}
                  </td>
                  <td
                    :class="{
                      day_is_weekend: checkDayForWeekend(dep.registration)
                    }"
                  >
                    {{ formatDate(dep.registration) }}
                  </td>
                  <td
                    :class="{
                      reg_hours: checkRegisterTime(formatTime(dep.registration))
                    }"
                  >
                    {{ formatTime(dep.registration) }}
                  </td>
                  <td>
                    {{
                      timeIcons[checkTimeOfDay(formatTime(dep.registration))]
                    }}
                  </td>
                  <td>
                    <span class="numeric-diff">{{
                      dep.difference_numeric
                    }}</span>
                    <span>{{ dep.difference }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Stats Segment -->
          <div class="stats-box" v-if="selectedSecTab === 'STATS'">
            <span
              class="stat-segment-opener"
              v-if="stats[tab.alias][filterOption]['reg_and_dep']"
              >Number of deposits made from {{ tab.alias }} registration:{{
                stats[tab.alias][filterOption]["reg_and_dep"]
              }}
            </span>
            <span
              class="stat-segment-opener"
              v-if="stats[tab.alias][filterOption]['weekend_register']"
              >Number of registrations made during the weekend:{{
                stats[tab.alias][filterOption]["weekend_register"]
              }}
            </span>
            <span
              class="stat-segment-opener"
              v-if="stats[tab.alias][filterOption]['weekend_deposits']"
              >Number of deposits made during the weekend:{{
                stats[tab.alias][filterOption]["weekend_deposits"]
              }}
            </span>
            <div class="stats-initial-tables">
              <span
                class="table-divider"
                v-if="stats[tab.alias][filterOption]['agents']"
              >
                Total Agents:
                {{
                  Object.keys(stats[tab.alias][filterOption]["agents"]).length
                }}
                <table :id="'agentTable' + tab.alias">
                  <thead>
                    <tr>
                      <th>AGENT</th>
                      <th>
                        AMT
                        <button
                          v-on:click="
                            applySorting(1, 1, 'agentTable' + tab.alias)
                          "
                          class="btn btn-default btn-sm override"
                        >
                          <span
                            class="fa"
                            :class="{
                              'fas fa-sort-numeric-down':
                                sortOrder[1] === 'asc',
                              'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                            }"
                          ></span>
                        </button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(amount, stat) in stats[tab.alias][filterOption][
                        'agents'
                      ]"
                      :key="stat"
                    >
                      <td>
                        {{
                          salesPersonList.find(user => user.id === Number(stat))
                            .full_name | truncate(12)
                        }}
                      </td>
                      <td>{{ amount }}</td>
                    </tr>
                  </tbody>
                </table>
              </span>
              <span
                class="table-divider"
                v-if="stats[tab.alias][filterOption]['brokers']"
              >
                Brokers:
                {{
                  Object.values(
                    stats[tab.alias][filterOption]["brokers"]
                  ).reduce((prev, val) => prev + val, 0)
                }}
                <table :id="'brokerTable' + tab.alias">
                  <thead>
                    <tr>
                      <th>BRKR</th>
                      <th>
                        AMT
                        <button
                          v-on:click="
                            applySorting(1, 1, 'brokerTable' + tab.alias)
                          "
                          class="btn btn-default btn-sm override"
                        >
                          <span
                            class="fa"
                            :class="{
                              'fas fa-sort-numeric-down':
                                sortOrder[1] === 'asc',
                              'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                            }"
                          ></span>
                        </button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(amount, stat) in stats[tab.alias][filterOption][
                        'brokers'
                      ]"
                      :key="stat"
                    >
                      <td
                        v-if="
                          dictionaries.general.brokers.find(
                            broker => broker.id == stat
                          ) !== undefined
                        "
                      >
                        {{
                          dictionaries.general.brokers.find(
                            broker => broker.id == stat
                          ).name | truncate(10)
                        }}
                      </td>
                      <td>{{ amount }}</td>
                    </tr>
                  </tbody>
                </table>
              </span>
              <span
                class="table-divider"
                v-if="stats[tab.alias][filterOption]['countries']"
              >
                Total Countries:
                {{
                  Object.keys(stats[tab.alias][filterOption]["countries"])
                    .length
                }}
                <table :id="'countryTable' + tab.alias">
                  <thead>
                    <tr>
                      <th>COUNTRY</th>
                      <th></th>
                      <th>
                        AMT
                        <button
                          v-on:click="
                            applySorting(1, 2, 'countryTable' + tab.alias)
                          "
                          class="btn btn-default btn-sm override"
                        >
                          <span
                            class="fa"
                            :class="{
                              'fas fa-sort-numeric-down':
                                sortOrder[1] === 'asc',
                              'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                            }"
                          ></span>
                        </button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(amount, stat) in stats[tab.alias][filterOption][
                        'countries'
                      ]"
                      :key="stat"
                    >
                      <td>
                        {{
                          dictionaries.general.countries.find(
                            place => place.id == stat
                          ).name | truncate(12)
                        }}
                      </td>
                      <td>
                        <img
                          class="country-flag"
                          :src="
                            '/img/flags/' +
                            dictionaries.general.countries
                              .find(place => place.id == stat)
                              .alpha2.toLowerCase() +
                            '.png'
                              ? '/img/flags/' +
                                dictionaries.general.countries
                                  .find(place => place.id == stat)
                                  .alpha2.toLowerCase() +
                                '.png'
                              : ''
                          "
                          alt="country-flag"
                        />
                      </td>
                      <td>{{ amount }}</td>
                    </tr>
                  </tbody>
                </table>
              </span>
              <span
                class="table-divider"
                v-if="stats[tab.alias][filterOption]['country_tier']"
              >
                Tiers:
                <table :id="'tierTable' + tab.alias">
                  <thead>
                    <tr>
                      <th>TIER</th>
                      <th>
                        AMT
                        <button
                          v-on:click="
                            applySorting(1, 1, 'tierTable' + tab.alias)
                          "
                          class="btn btn-default btn-sm override"
                        >
                          <span
                            class="fa"
                            :class="{
                              'fas fa-sort-numeric-down':
                                sortOrder[1] === 'asc',
                              'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                            }"
                          ></span>
                        </button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(amount, stat) in stats[tab.alias][filterOption][
                        'country_tier'
                      ]"
                      :key="stat"
                    >
                      <td>
                        {{ stat }}
                      </td>
                      <td>{{ amount }}</td>
                    </tr>
                  </tbody>
                </table>
              </span>
              <span
                class="table-divider"
                v-if="stats[tab.alias][filterOption]['amounts']"
              >
                Total Sum:
                {{ getTotalSum(stats[tab.alias][filterOption]["amounts"]) }}
                <table :id="'sumTable' + tab.alias">
                  <thead>
                    <tr>
                      <th>DEP-AMT</th>
                      <th>
                        AMT
                        <button
                          v-on:click="
                            applySorting(1, 1, 'sumTable' + tab.alias)
                          "
                          class="btn btn-default btn-sm override"
                        >
                          <span
                            class="fa"
                            :class="{
                              'fas fa-sort-numeric-down':
                                sortOrder[1] === 'asc',
                              'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                            }"
                          ></span>
                        </button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(amount, stat) in stats[tab.alias][filterOption][
                        'amounts'
                      ]"
                      :key="stat"
                    >
                      <td>
                        {{ stat }}
                      </td>
                      <td>{{ amount }}</td>
                    </tr>
                  </tbody>
                </table>
              </span>
              <span
                class="table-divider"
                v-if="stats[tab.alias][filterOption]['deposit_time']"
              >
                Deposit:
                <table :id="'depTable' + tab.alias">
                  <thead>
                    <tr>
                      <th>TIME</th>
                      <th>
                        AMT
                        <button
                          v-on:click="
                            applySorting(1, 1, 'depTable' + tab.alias)
                          "
                          class="btn btn-default btn-sm override"
                        >
                          <span
                            class="fa"
                            :class="{
                              'fas fa-sort-numeric-down':
                                sortOrder[1] === 'asc',
                              'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                            }"
                          ></span>
                        </button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(amount, stat) in stats[tab.alias][filterOption][
                        'deposit_time'
                      ]"
                      :key="stat"
                    >
                      <td>
                        {{ stat }}
                      </td>
                      <td>{{ amount }}</td>
                    </tr>
                  </tbody>
                </table>
              </span>
              <span
                class="table-divider"
                v-if="stats[tab.alias][filterOption]['register_time']"
              >
                Register:
                {{
                  Object.values(
                    stats[tab.alias][filterOption]["register_time"]
                  ).reduce((prev, val) => prev + val, 0)
                }}
                <table :id="'regTable' + tab.alias">
                  <thead>
                    <tr>
                      <th>TIME</th>
                      <th>
                        AMT
                        <button
                          v-on:click="
                            applySorting(1, 1, 'regTable' + tab.alias)
                          "
                          class="btn btn-default btn-sm override"
                        >
                          <span
                            class="fa"
                            :class="{
                              'fas fa-sort-numeric-down':
                                sortOrder[1] === 'asc',
                              'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                            }"
                          ></span>
                        </button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(amount, stat) in stats[tab.alias][filterOption][
                        'register_time'
                      ]"
                      :key="stat"
                    >
                      <td>
                        {{ stat }}
                      </td>
                      <td>{{ amount }}</td>
                    </tr>
                  </tbody>
                </table>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../helpers/api/request";
import moment from "moment";

export default {
  name: "DepositsReports.container",
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [ "dictionaries", "salesPersonList"])
  },
  props: {
    depTab: {
      type: String
    },
    fromChart: {
      type: Boolean
    }
  },
  data() {
    return {
      reportBusy: false,
      filterOption: "regular",
      report: [],
      stats: [],
      lastComment: 0,
      sortOrder: {
        0: "desc",
        1: "desc"
      },
      timeIcons: [
        "\uD83C\uDF05",
        "\uD83C\uDF1E",
        "\uD83C\uDF07",
        "\uD83C\uDF19"
      ],
      statsTabs: [
        {
          id: 0,
          name: "T",
          alias: "today"
        },
        {
          id: 1,
          name: "Y",
          alias: "yesterday"
        },
        {
          id: 2,
          name: "T-M",
          alias: "this_month"
        },
        {
          id: 3,
          name: "L-M",
          alias: "last_month"
        }
      ],
      selectedStatsTab: "today",
      secTabs: [
        {
          id: 0,
          name: "count",
          alias: "COUNT"
        },
        {
          id: 1,
          name: "stats",
          alias: "STATS"
        }
      ],
      selectedSecTab: "COUNT"
    };
  },
  created() {
    this.getDepositsReport();
  },
  watch: {
    depTab: function() {
      this.selectedSecTab = this.depTab;
    }
  },
  methods: {
    checkDayForWeekend(date) {
      return moment(date).weekday() === 0 || moment(date).weekday() === 6;
    },
    filterClientById(clientId) {
      this.$store.commit("clients/setFilterClientById", clientId);
    },
    async getDepositsReport() {
      try {
        const res = await apiClientCreator(`reports/deposits/shortcuts`).get(
          ""
        );
        this.report = res.data["report"];
        this.stats = res.data["stats"];
      } catch (e) {}
    },
    changeFilter(event) {
      this.filterOption = event.target.value;
    },
    formatDate(date) {
      return moment(String(date)).format("DD/MM/YY");
    },
    formatTime(time) {
      return moment(String(time)).format("HH:mm");
    },
    checkTimeOfDay(time) {
      let format = "hh:mm:ss";

      let timeToCheck = moment(time, format);
      let midnight = moment("00:00:00", format),
        earlyMorning = moment("06:00:00", format),
        noon = moment("12:00:00", format),
        evening = moment("18:00:00", format),
        night = moment("23:59:59", format);
      if (timeToCheck.isBetween(midnight, earlyMorning, undefined, "[)"))
        return 3;
      if (timeToCheck.isBetween(earlyMorning, noon, undefined, "[)")) return 0;
      if (timeToCheck.isBetween(noon, evening, undefined, "[)")) return 1;
      if (timeToCheck.isBetween(evening, night, undefined, "[)")) return 2;
    },
    checkRegisterTime(time) {
      let format = "hh:mm:ss";

      let timeToCheck = moment(time, format);

      return !timeToCheck.isBetween(
        moment("08:00:00", format),
        moment("23:00:00", format),
        undefined,
        "()"
      );
    },
    showComment(id) {
      if (id !== this.lastComment && this.lastComment !== 0) {
        let lastPopUp = document.getElementById(this.lastComment);
        if (lastPopUp.classList.contains("show")) {
          lastPopUp.classList.toggle("show");
        }
      }
      let popup = document.getElementById(id);
      popup.classList.toggle("show");
      this.lastComment = id;
    },
    applySorting(typeSort, tableColumn, tableId) {
      let table,
        rows,
        switching,
        i,
        x,
        y,
        shouldSwitch,
        switchcount = 0;
      table = document.getElementById(tableId);
      switching = true;
      this.sortOrder[typeSort] = "desc";
      while (switching) {
        switching = false;
        rows = table.rows;
        for (i = 1; i < rows.length - 1; i++) {
          shouldSwitch = false;
          x = rows[i].getElementsByTagName("TD")[tableColumn];
          y = rows[i + 1].getElementsByTagName("TD")[tableColumn];
          if (tableColumn === 15) {
            x = x.getElementsByClassName("numeric-diff")[0];
            y = y.getElementsByClassName("numeric-diff")[0];
          }
          if (this.sortOrder[typeSort] === "desc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else {
              if (Number(x.innerHTML) < Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          } else if (this.sortOrder[typeSort] === "asc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else {
              if (Number(x.innerHTML) > Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          }
        }
        if (shouldSwitch) {
          rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
          switching = true;
          switchcount++;
        } else {
          if (switchcount === 0 && this.sortOrder[typeSort] === "desc") {
            this.sortOrder[typeSort] = "asc";
            switching = true;
          }
        }
      }
    },
    applyMailSorting(typeSort, tableColumn, tableId) {
      let table,
        rows,
        switching,
        i,
        x,
        y,
        shouldSwitch,
        switchcount = 0;
      table = document.getElementById(tableId);
      switching = true;
      this.sortOrder[typeSort] = "desc";
      while (switching) {
        switching = false;
        rows = table.rows;
        for (i = 1; i < rows.length - 1; i++) {
          shouldSwitch = false;
          x = rows[i].getElementsByTagName("TD")[tableColumn];
          y = rows[i + 1].getElementsByTagName("TD")[tableColumn];
          if (this.sortOrder[typeSort] === "desc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else {
              if (Number(x.innerHTML) < Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          } else if (this.sortOrder[typeSort] === "asc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else {
              if (Number(x.innerHTML) > Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          }
        }
        if (shouldSwitch) {
          rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
          switching = true;
          switchcount++;
        } else {
          if (switchcount === 0 && this.sortOrder[typeSort] === "desc") {
            this.sortOrder[typeSort] = "asc";
            switching = true;
          }
        }
      }
    },
    getTotalSum(amounts) {
      return Object.keys(amounts).reduce(
        (previous, key) => previous + amounts[key] * key,
        0
      );
    }
  }
};
</script>

<style scoped>
table {
  width: 100%;
}
table,
th,
td {
  border-collapse: collapse;
  padding: 0.1em 0.2em;
  white-space: nowrap;
}
table,
th {
  direction: ltr;
  position: sticky;
  top: 0;
  background: white;
  vertical-align: initial;
  width: 45px;
}
.chart-box {
  display: flex;
  background-color: white;
  flex-direction: column;
  direction: rtl;
}
.main-tabs {
  max-width: 8%;
  max-height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  position: relative;
  background: white;
  flex: 2;
}

.main-tabs.style2 li {
  max-height: 10%;
  border-radius: 5px 5px 0 0;
  transition: transform 0.1s ease;
}

.main-tabs li {
  max-width: 100%;
  min-width: 70px;
  font-size: 0.6vw;
  height: 18px;
  cursor: pointer;
  background: white;
  border-radius: 0;
  text-align: left;
  vertical-align: middle;
  line-height: 25px;
  border-bottom: 2px solid transparent;
  transition: background 0.2s ease, color 0.2s ease;
}

.main-tabs li:not(.empty):hover {
  transform: translateY(1px);
}

.main-tabs li.active {
  border-bottom: 1px solid #44a2d2 !important;
  color: #44a2d2;
}

.main-tabs.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.main-tabs.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
.daily-stats-tabs {
  display: flex;
  justify-content: space-between;
  font-size: 0.7vw;
}
.report-rank {
  font-size: 0.6vw;
}
.negative {
  color: red;
}
.positive {
  color: green;
}
.time-title {
  font-weight: bold;
  padding: 1em 0 1em 0;
}
.deposits-data {
  display: flex;
}
.filter-buttons {
  font-size: 0.6vw;
}
.country-flag {
  margin-top: -3px;
  margin-left: -2px;
}

.popup {
  position: relative;
  display: inline-block;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.popup .popuptext {
  visibility: hidden;
  width: 400px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px 0;
  position: absolute;
  z-index: 1;
  bottom: -180%;
  left: 50%;
  margin-left: -80px;
}

.popup .show {
  visibility: visible;
}
.btn-sm {
  padding: 0 1px 3px 0;
  font-size: 0.7vw;
  line-height: 1.5;
  border: none;
}
.btn-sm:active {
  border: none;
  outline: none;
  background: #e0e0e0;
}
.btn-sm:focus {
  border: none;
  outline: none;
}
.dep-report-tab {
  overflow-y: scroll;
  font-size: 0.61vw;
  display: flex;
  flex-direction: column;
  height: 200px;
  min-width: 100%;
}
.stats-initial-tables {
  display: flex;
  padding-bottom: 10px;
}
.table-divider {
  padding: 0 0.3em 0 0;
}
.stat-segment-opener {
  padding: 10px 0;
}
.client_id_label:hover {
  cursor: pointer;
  background-color: #efefef;
}
.day_is_weekend {
  background-color: #f9a825;
}
.reg_hours {
  background-color: grey;
}

.tooltip-text {
  visibility: hidden;
  width: 15vw;
  font-size: 0.7vw;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
}

.tooltip-opener:hover .tooltip-text {
  visibility: visible;
}
.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
}
.style-nav.style2 li {
  /*border-radius: 5px 5px 0px 0px;*/
  transition: transform 0.1s ease;
}
.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 100%;
  min-width: 72px;
  height: 30px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(4px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
  /* transform: translateY(4px);*/
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
.report-box {
  width: 100%;
}
.stats-box {
  display: flex;
  flex-direction: column;
}
.diff-tr {
  display: flex;
  flex-direction: column-reverse;
}
.diff-wrapper {
  display: flex;
}
.numeric-diff {
  display: none;
}
.reg-bg > span {
  background-color: #008b00;
  color: #fff;
}
.dep-bg > span {
  background-color: #c12fff;
  color: #fff;
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
::-webkit-scrollbar-thumb {
  background: #c12fff;
  border-radius: 12px;
}
::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(13deg, #ffc7fc 14%, #f9d4ff 64%);
}
::-webkit-scrollbar-track {
  background: #ffffff;
  border-radius: 10px;
  box-shadow: inset 7px 10px 12px #f0f0f0;
}
.report-calendar .mx-table-date td,
.mx-table-date th {
  height: 5px !important;
  font-size: 9px !important;
}
</style>
